import styled from 'styled-components';

import Dropdown from 'src/presentation/components/forms/Dropdown';

export const LabelContainer = styled.div`
  align-self: flex-start;
  display: flex;
  font-weight: bolder;
  height: 100%;
  justify-content: start;
  margin-bottom: 8px;
  min-height: 18px;
  width: 56px;
`;

export const ThenContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing.insetMedium};
  max-width: 400px;
`;

export const StyledMemoryDropdown = styled(Dropdown)`
  flex: unset;
`;
